/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:11:05
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-02 11:33:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/TopConfigs/IconStyle/index.tsx
 */
import React from 'react';
import { Menu } from 'antd';
import css from './css.less';

import { DropDown } from '@/src/components/Antd';
import { useSelector, useDispatch } from 'react-redux';

import { Icon } from '@/src/tools/icon';
import _ColorPickerWidthTitle from 'src/pages/SalesChannelContentEditor/Components/ColorPickerWidthTitle';
import { Collapse } from '@/src/components/Antd';

import { EnumCollapseId } from '../../common';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import {
  getCollapseStatus,
  onIconStyleChange,
  onCollapseOpen,
} from '../../slice';

import styles from './css.less';

const IconStyle = (props) => {
  const _d = useDispatch();
  const _open = useSelector(getCollapseStatus(EnumCollapseId.iconStyle));
  const { colour } = useSelector(
    (state: any) => state.salesChannelContent.homepage.iconStyle,
  );
  const [dropVisible, setDropVisible] = React.useState(false);
  const handleOnColorChange = (color, e) => {
    if (e) {
      e.stopPropagation();
    }
    _d(onIconStyleChange({ colour: color }));
    setDropVisible(false);
  };

  const handleOnCollapseOpen = (open) => {
    if (open) {
      _d(onCollapseOpen({ idArr: [EnumCollapseId.iconStyle] }));
    } else {
      _d(onCollapseOpen({ idArr: [] }));
    }
  };

  const renderMenu = () => {
    return (
      <div className='override'>
        <Menu selectedKeys={[]}>
          <Menu.Item key='resetStyle'>
            <div
              onClick={handleOnColorChange.bind(this, '#000')}
              style={{ color: '#FF695F' }}>
              {'Reset Style'}
            </div>
          </Menu.Item>
        </Menu>
      </div>
    );
  };

  const renderTitle = () => {
    return (
      <div className={styles.title}>
        <span>{'Icon Style'}</span>
        <span className={styles.dropdown}>
          <DropDown
            visible={dropVisible}
            onVisibleChange={setDropVisible}
            overlay={renderMenu()}
            trigger={['click']}>
            <Icon
              type='iconMore'
              className={styles.more}
              onClick={(e) => e.stopPropagation()}
            />
          </DropDown>
        </span>
      </div>
    );
  };
  return (
    <div className={css.container}>
      <Collapse
        id={EnumCollapseId.iconStyle}
        open={_open}
        title={renderTitle()}
        content={
          <Section className={css.sectionContainer}>
            {' '}
            <_ColorPickerWidthTitle
              multi
              onChange={handleOnColorChange}
              color={colour}
              title={'Icon Color'}
              subtitle={'Search icon & multi languages icon'}
            />
          </Section>
        }
        clickToExpand
        //open={true}
        expandOffset={12}
        onClickTrigger={handleOnCollapseOpen}
      />
    </div>
  );
};
export default IconStyle;
